import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import ModalFormTextInput from '@/components/business/ModalForm/ModalFormTextInput/ModalFormTextInput';
import ModalFormDatepicker from '@/components/business/ModalForm/ModalFormDatepicker/ModalFormDatepicker';
import { ContractLineBillingCycleOutput, ContractLineGridOutput } from '@/graphql/contracts/_generated_/contracts';
import { isValidDate } from '@/utils/date.utils';

interface ILineBillingInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  contractLine: ContractLineBillingCycleOutput | ContractLineGridOutput | null;
}

export default function LineBillingInfoModal({
  isOpen,
  onClose,
  contractLine
}: ILineBillingInfoModalProps) {
  if (!isOpen || !contractLine) return null;

  return (
    <AgModalWindow
      title="Pause Details"
      isOpen={true}
      onClose={onClose}
      contentStyle={{ width: 400 }}
    >
      <div className="mb-15">
        <ModalFormDatepicker
          id="currentStatusEndDate"
          labelTitle="End Date"
          disabled={true}
          onChange={() => {}}
          value={
            contractLine.lineBillingCurrentStatusEndDate
                && isValidDate(new Date(contractLine.lineBillingCurrentStatusEndDate)) 
              ? new Date(contractLine.lineBillingCurrentStatusEndDate) 
              : undefined
          }
        />
      </div>
      
      <div className="mb-15">
        <ModalFormTextInput
          id="statusUpdateComment"
          labelTitle="Comment"
          value={contractLine.lineBillingStatusUpdateComment || ''}
          disabled={true}
          readOnly={true}
        />
      </div>
      
      <div className="mb-15">
        <ModalFormTextInput
          id="statusUpdateReasonCode"
          labelTitle="Reason Code"
          value={contractLine.lineBillingStatusUpdateReasonCode || ''}
          disabled={true}
          readOnly={true}
        />
      </div>
      
      <div className="mb-15">
        <ModalFormTextInput
          id="statusUpdateReference"
          labelTitle="Reference"
          value={contractLine.lineBillingStatusUpdateReference || ''}
          disabled={true}
          readOnly={true}
        />
      </div>
      
      <div className="mb-15">
        <ModalFormDatepicker
          id="statusUpdated"
          labelTitle="Updated Date"
          disabled={true}
          onChange={() => {}}
          value={
            contractLine.lineBillingStatusUpdated && isValidDate(new Date(contractLine.lineBillingStatusUpdated)) 
              ? new Date(contractLine.lineBillingStatusUpdated) 
              : undefined
          }
        />
      </div>
    </AgModalWindow>
  );
}
